import React, { Component } from 'react';
import './News.css'
import Header from '../../Components/header/Header'
import Banner from '../../Components/banner/Banner'
import Contact from '../../Components/footer-contact/Contact'
import { Link } from 'react-router-dom'
import { post, get, urlHOST } from '../../Utils/request'

class News extends Component {
    constructor (params) {
        super(params);
        this.state = {
            newsdetails: '',
            newslist: [],
            detailstime: '',
            id:''
        };
        this.getedata = this.getedata.bind(this)
    }

    updata(id){
        console.log("方法",id)
        this.props.history.push(`/dynamic/${this.props.match.params.page}/news/${id}`)
        this.getedata(id)
    }

    getedata(id) {
        post('/news/list', {
            "page": 1
        }).then(res => {
            this.setState({
                newslist: res.List
            })
        })

        post('/news/details', {
                "news_id": id
        }).then(res => {
            // console.log("新闻详情", res)
            this.setState({
                id: res.news_id,
                newsdetails: res,
                detailstime: res.created_at.split(' ')
            })

        })
    }


    // 请求数据
    componentDidMount() {
        this.getedata(this.props.match.params.id * 1);
    }
    //解决页面更新问题
    // componentDidUpdate() {
    //     this.getedata();
    // }
    // 解决componentDidUpdate死循环
    // shouldComponentUpdate(nextProps, nextState) {
    //     return nextProps.match.params.id != this.props.match.params.id || nextState.newsdetails.news_id != this.state.newsdetails.news_id
    // }


    // componentWillReceiveProps(nextProps) {
    //     console.log('前',this.state.id)
    //     if(nextProps.match.params.id*1!=this.state.id){
    //         this.setState({
    //             id:nextProps.match.params.id*1
    //         },()=>{
    //             console.log('后',this.state.id)
    //         })
    //     }
    // }

    render() {
        let details = decodeURI(this.state.newsdetails.details);
        console.log(details)
        return (
            <div className="newsdetails">
                {/* 公共头部组件 */}
                <Header push={this.props.history.push} propsEnroll={this.props} />
                <Banner />
                {/* 顶端图片黑色背景 */}
                {/* <div className="background"></div> */}

                {/* 头部标题 */}
                <div className="main-nav">
                    <p>
                        <Link to='/'>首页</Link>
                        >
                        <Link to={`/dynamic/${this.props.match.params.page}`}>赛事动态</Link>
                        >
                        <Link to={`/dynamic/${this.props.match.params.page}/news/${this.props.match.params.id}`}>新闻详情</Link>
                    </p>
                </div>

                {/* 主体部分 */}
                <div className="main-content">
                    {/* 左侧 */}
                    <div className="main-left">
                        {/* 左侧标题栏 */}
                        <div className="main-left-title">
                            <span className="main-left-title-time">{this.state.detailstime[0]}</span>
                            <div className="main-left-title-line"></div>
                            <span className="main-left-title-word">{this.state.newsdetails.tittle}</span>
                        </div>
                        {/* 新闻详情（富文本） */}
        
                        <div className="main-left-text" >
                            {details === undefined||details ===''||details ===null ? null :  <div dangerouslySetInnerHTML={{ __html: details }}></div> }
                            
                        </div>
                        
                        

                    </div>

                    {/* 右侧 */}
                    <div className="main-right">
                        {/* 右侧标题栏 */}
                        <Link to={`/dynamic/${this.props.match.params.page}`} >
                            <div className="main-right-title">
                                <span>查看更多</span>
                                <img alt="" src='/img/learnmore.png' />
                            </div>
                        </Link>

                        {/* 右侧新闻展示区 */}
                        <ul>
                            {
                                this.state.newslist.length > 0 && this.state.newslist.map((obj, index) => {
                                    // console.log('11', index)
                                    return <li key={index} className="main-right-show">
                                        {/* to={`/dynamic/news/${obj.news_id}`} */}
                                        <div key={index}  onClick={this.updata.bind(this,obj.news_id)}>
                                            {/* 展示区内部标题栏 */}
                                            <div className="main-right-show-title">
                                                <span className="main-right-show-title-time">{obj.created_at.split(' ')[0]}</span>
                                                <div className="main-right-show-title-line"></div>
                                                <span className="main-right-show-title-word">{obj.tittle}</span>
                                            </div>
                                            {/* 展示区内部新闻 */}
                                            <div className="main-right-show-news" dangerouslySetInnerHTML={{ __html: decodeURI(obj.details).replace(/<[^>]+>/g, "") }}>
                                            </div>
                                        </div>
                                    </li>
                                })
                            }
                        </ul>
                    </div>
                </div>
                <Contact />
            </div>
        );
    }
}

export default News;